import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useRisingEdgeEffect } from 'src/clientLib/hooks'
import { getProject, uploadGISFile } from 'src/redux/slices/project/endpoints'

import { LinearProgress, TextField } from '@material-ui/core'

///// Types
type DropzoneGISProps = {
  toggleDropzone: () => void
}

///// Components
const DropzoneGIS: React.FC<DropzoneGISProps> = ({ toggleDropzone }) => {
  const { data: project, isLoading } = getProject.useQuery('')
  const [trigger, { data: fileUploadData, isLoading: isUploadingGIS }] = uploadGISFile.useMutation({
    fixedCacheKey: 'uploadGISFile',
  })

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (!project) return
      const { organization_id, id, gis_file_version } = project
      acceptedFiles.forEach(async (file) => {
        trigger({ organization_id, id, file, gis_file_version })
      })
    },
    [project, trigger],
  )

  useRisingEdgeEffect({
    callback: toggleDropzone,
    condition: fileUploadData && !isUploadingGIS,
  })

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } = useDropzone({
    accept:
      'application/zip, .geojson, application/json, application/x-zip-compressed, multipart/x-zip,',
    maxFiles: 1,
    onDrop,
  })

  if (isLoading || isUploadingGIS) return <LinearProgress />
  return (
    <div {...getRootProps()}>
      <TextField
        size='small'
        fullWidth
        label={'Upload a GIS File to get started'}
        value={acceptedFiles?.[0]?.name ?? ''}
      />
      <input {...getInputProps()} />
    </div>
  )
}

export default DropzoneGIS
